<template>
  <main class="inbox-page">
    <h1 class="inbox-page__header">Chats and stories</h1>
    <section class="conversations">
      <router-link
        v-for="chat in chats"
        :key="chat.id"
        :to="getChatPageUrl(chat.id)"
        replace
      >
        <ConversationBox
         v-if="chat && chat.profilePhoto"
          :unreaded="getUnreadedMessages(chat)"
          :name="getFormattedChatName(chat.name)"
          :images="chat.profilePhoto"
        >
          {{
            displayFormattedLastMessage(getChatLastMessage(chat.id), chat.id)
          }}
        </ConversationBox>
      </router-link>
    </section>
    <!-- / conversations -->

    <!-- <a href="#" class="inbox-page__reset-btn" @click="clearLocalState()"></a> -->
    <!-- / inbox-page__reset-btn -->

    <div class="page-loader" v-show="showLoader"></div>
    <!-- / .page-loader -->
  </main>
</template>

<style scoped lang="scss">
.page-loader {
  width: 100vw;
  height: 100vh;
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(black, 0.65) url("../assets/images/i-spinner.svg") no-repeat
    center;
  background-size: 40px 40px;
  z-index: 10000;
}

.inbox-page {
  max-width: $grid-max-width;
  margin-right: auto;
  margin-left: auto;

  &__header {
    padding: 40px 20px 20px 20px;
    font-family: $font-alt;
    letter-spacing: 0.6px;
    color: $txt-color;
    font-weight: 700;
    font-size: 15px;

    @media #{$bigger-mobile} {
      font-size: 18px;
    }
  }

  &__reset-btn {
    display: block;
    width: 54px;
    height: 34px;
    background: url("../assets/images/i-erase.svg") no-repeat center;
    background-size: 20px 20px;
    border-radius: 999px;
    box-shadow: 0px 3px 13px 0 rgba($txt-color, 0.1);

    position: fixed;
    bottom: 10px;
    right: 10px;
  }
}

.conversations {
  position: relative;
  width: 100%;
}
</style>

<script>
import ConversationBox from "@/components/ConversationBox.vue";

export default {
  name: "Inbox",
  components: {
    ConversationBox
  },
  data: function() {
    return {
      conversation: {
        people: [
          "Patrick",
          "Selena",
          "Max",
          "Trisha",
          "Paul",
          "Amanda",
          "Robert",
          "George"
        ]
      },
      showLoader: false
    };
  },
  methods: {
    getChatPageUrl(id) {
      const { token } = this.$route.query;
      let url = `/${
        this.$route.params.phone_number
      }${this.$store.getters.getChatPageUrl(id)}`;

      if (token) {
        url = `${url}?token=${token}`;
      }

      return url;
    },
    getFormattedChatName(chatName) {
      return this.$store.getters.getFormattedChatName(chatName);
    },
    getChatLastMessage(id) {
      return this.$store.getters.getChatLastMessage(id);
    },
    displayFormattedLastMessage(message, chatId) {
      if (message) {
        const author = message.author ? message.author.split("-")[0] : "Meg";
        let content = message.value ? message.value : "";
        let messageContent = `${
          author != chatId ? author + ": " : ""
        }${content}`;

        if (message.content_type == "image") {
          if (author) {
            messageContent = `${author} sendte et bilde.`;
          } else {
            messageContent = "Du sendte et bilde.";
          }
        } else if (message.content_type == "video") {
          if (author) {
            messageContent = `${author} sendte en video.`;
          } else {
            messageContent = "Du sendte en video.";
          }
        }
        return messageContent;
      }
    },
    getUnreadedMessages(chat) {
      // code to use for unreaded messages
      let lastIndex = 0;
      let i = 0;
      chat.messages.forEach(el => {
        if (el.author == 0) {
          lastIndex = i;
        }
        i++;
      });

      const unreadedMessages = chat.messages.slice(lastIndex, -1);
      return unreadedMessages && chat.script.length
        ? unreadedMessages.length
        : 0;
    },
    clearLocalState() {
      this.$store.dispatch("clearLocalState");
      this.showLoader = true;
    }
  },
  computed: {
    chats() {
      return this.$store.getters.getAllActiveChats();
    }
  },
};
</script>
